import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GetAriaSortPipeModule, GetSortDirectionPipeModule, MtnaHeaderSortModule } from '@mtna/core-angular';

import { RdsSelectTableDecoratorsComponent } from './decorators.component';
import { RdsGetRecordValuePipe } from './get-record-value.pipe';
import { RdsIsRecordValueNumberPipe } from './is-number.pipe';
import { RdsSelectTableComponent } from './select-table.component';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    MatCheckboxModule,
    MatIconModule,
    MatTableModule,
    MatRippleModule,
    MatTooltipModule,
    MtnaHeaderSortModule,
    GetAriaSortPipeModule,
    GetSortDirectionPipeModule,
  ],
  declarations: [RdsSelectTableComponent, RdsSelectTableDecoratorsComponent, RdsGetRecordValuePipe, RdsIsRecordValueNumberPipe],
  exports: [RdsSelectTableComponent, RdsSelectTableDecoratorsComponent, RdsGetRecordValuePipe, RdsIsRecordValueNumberPipe],
  providers: [RdsGetRecordValuePipe],
})
export class RdsSelectTableModule {}

export * from './decorators.component';
export * from './get-record-value.pipe';
export * from './is-number.pipe';
export * from './select-table.component';
